import React, { useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

function FootyCash() {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div>
            <Header />
            {isLoading && <div className="loaderScratch">Loading Footy Cash...</div>}

            <div style={{ width: "100%", height: "100vh", overflow: "hidden", position: "relative" }}>
            <iframe
                title="FootyCash Prototype"
                src="https://embed.figma.com/proto/V6KqM2bve1KdylXS0O0bxu/Footycash?page-id=105%3A1901&node-id=105-1902&viewport=-1040%2C1769%2C0.45&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=105%3A1902&embed-host=share&hide-ui=1"
                allowFullScreen
                style={{
                    width: "100%",
                    height: "100vh",
                    border: "none"
                }}
                onLoad={() => setIsLoading(false)}
            ></iframe>
            </div>

            <Footer />
        </div>
    );
}

export default FootyCash;
